import React, { Component } from 'react'
import { get } from "lodash"

import {
  getValidateMailMessage,
  checkIsValidMail,
  isFailureMailValidation,
} from "./static.mailData"

import { withStepsState } from "../../../shared/containers/containerStepsState"
import { withLoader } from "../../../shared/containers/containerLoader"

import ButtonFill from "../../../shared/items/controls/buttonFill"

function validateEmail(email) {
  // const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const re = /^(([^<>()[\]\\$&%#.,;:\s@\"]+(\.[^<>()[\]\\$&%#.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
  return re.test(email);
}

class MailNextStepButton extends Component {
  constructor(props) {
    super(props)
    this.validate = this.validate.bind(this);
  }

  componentDidUpdate() {
    const { data, onSetSuccessValidate, onSetFailValidate } = this.props

    if (checkIsValidMail(data)) {
      onSetSuccessValidate("mail")

    }

    if (isFailureMailValidation(data))
      onSetFailValidate("mail", getValidateMailMessage(get(data, ["mail", "value"], null)))
  }

  validate(data) {
    let isLengthValid = (get(data, ["mail", "value"]) && (get(data, ["mail", "value"]).length < 63));
    let isMailValid = validateEmail(get(data, ["mail", "value"]));

    if (isLengthValid === true && isMailValid === true) {
      return false;
    } else return true;
  }

  render() {
    const { data, onOpenLoader } = this.props

    function goNext() {
      onOpenLoader();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        {
          'email': get(data, ["mail", "value"])
        },
        {
          'event': 'funnel on onboarding',
          'quiz_action': 'email send'
        }
      );
    }

    return (
      <ButtonFill disabled={this.validate(data)} onClick={goNext}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(withLoader(MailNextStepButton))